import React, { useState } from "react";
import "./GradeBookTable.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip
} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";

const GradeBookTable = ({ quizzes, studentsData, onViewReport }) => {
  // quizzes: array of quizzes { id, title }
  // studentsData: object containing each student's info + attempts for each quiz
  // onViewReport: function(sessionId) => fetch report

  return (
    <TableContainer component={Paper} className="gradebook-table-container">
      <Table>
        {/* Header row: first col is "Student", then quiz titles */}
        <TableHead>
          <TableRow>
            <TableCell className="sticky-col left-col">Student</TableCell>
            {quizzes.map((quiz) => (
              <TableCell key={quiz.id} align="center">
                {quiz.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {Object.values(studentsData).map((student) => (
            <TableRow key={student.id}>
              {/* Student name col */}
              <TableCell className="sticky-col left-col student-name-cell">
                {student.name}
              </TableCell>

              {quizzes.map((quiz) => {
                const attempts = student.quizzes[quiz.id] || [];
                return (
                  <TableCell key={quiz.id} align="center">
                    {/* Render attempts in a stacked manner */}
                    {attempts.length > 0 ? (
                      attempts.map((attemptData, idx) => (
                        <div key={idx} className="attempt-cell">
                          Attempt {attemptData.attempt}:{" "}
                          {attemptData.final_evaluation ?? "N/A"}%
                          <Tooltip title="View AI Report" arrow>
                            <IconButton
                              size="small"
                              onClick={() => onViewReport(attemptData.session_id)}
                              className="secondary-icon"
                            >
                              <ArticleIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ))
                    ) : (
                      <div className="no-attempts">—</div>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GradeBookTable;
